import { Injectable } from '@angular/core';
import { UsuarioModel } from '../models/usuario-model';
// import { RepresentadaModel } from '../models/representada-model';
import { ParametroModel } from '../models/parametro-model';
import { ClienteModel } from '../models/cliente-model';

@Injectable()
export class GlobalServiceProvider {

  public boolMenu: Boolean;
  // public usuarioNome: string;
  // public repCodigo: string;
  public usuario: UsuarioModel = new UsuarioModel();
  // public representada: RepresentadaModel = new RepresentadaModel();
  // public representadas: Array<RepresentadaModel>;
  public parametros: Array<ParametroModel>;

  private accessUrl: string;
  private userpass: string;
  private empresa: string;

  constructor() {
    this.boolMenu = false;
  }

  //-------------------------------------------------------------------
  /*/{WmsMais.doc} getVencimento
  Método utilizado para retornar o vencimento
  @author Kenny Roger Martins
  @since 30/01/2018
  /*/
  //-------------------------------------------------------------------
  getVencimento(dataVenc, numDias = 0, isDoc = false) {

    let lRet = false;
    let dataAtual = new Date();
    let dataConv = new Date(dataVenc.substr(6, 4) + '-' + dataVenc.substr(3, 2) + '-' + dataVenc.substr(0, 2) + ' 00:00:00');

    //----------------------------------------
    // Testa se a variável é do tipo data,
    // no safari a formatação é diferente.
    //----------------------------------------
    if (isNaN(dataConv.getDate())) {
      dataConv = new Date(dataVenc.substr(3, 2) + '/' + dataVenc.substr(0, 2) + '/' + dataVenc.substr(6, 4) + ' 00:00:00');
    }

    if (!isNaN(dataConv.getDate())) {
      if (isDoc) {
        if (Math.trunc((dataConv.getTime() - dataAtual.getTime()) / (1000 * 3600 * 24)) < numDias || dataVenc === '  /  /    ') {
          lRet = true;
        }
      } else {
        if (Math.trunc((dataConv.getTime() - dataAtual.getTime()) / (1000 * 3600 * 24)) < numDias) {
          lRet = true;
        }
      }
    }

    return lRet;

  }

  //-------------------------------------------------------------------
  /*/{WmsMais.doc} validaDocumentacao
  Método para validar a documntação do cliente
  @author Kenny Roger Martins
  @since 16/07/2020
  /*/
  //-------------------------------------------------------------------
  validaDocumentacao(cliente: ClienteModel, numDias: number = 0) {

    let valido = false;
    let doc1 = false;
    let doc2 = false;
    let doc3 = false;

    cliente.DOCUMENTOS.forEach(documento => {
      if (documento.DOC_CODIGO === '000001') {
        if (!this.getVencimento(documento.DOC_DATAVENC, numDias, true)) {
          doc1 = true;
        }
      }
      if (documento.DOC_CODIGO === '000003') {
        if (!this.getVencimento(documento.DOC_DATAVENC, numDias, true)) {
          doc2 = true;
        }
      }
      if (documento.DOC_CODIGO === '000004') {
        if (!this.getVencimento(documento.DOC_DATAVENC, numDias, true)) {
          doc3 = true;
        }
      }
    });

    if (cliente.CLI_TIPDOC === '0008') {

      valido = doc1;

    } else if (cliente.CLI_TIPDOC === '0005') {

      valido = doc1 && doc2 && doc3;

    } else if (cliente.CLI_TIPDOC === '0001' || cliente.CLI_TIPDOC === '0004' || cliente.CLI_TIPDOC === '0006') {

      valido = doc1 && doc3;

    } else if (cliente.CLI_TIPDOC === '0007') {

      valido = true;

    }

    return valido;
  }


  //-------------------------------------------------------------------
  /*/{WmsMais.doc} getColorRent
  Método utilizado para retornar cor da rentabilidade
  @author Kenny Roger Martins
  @since 30/01/2018
  /*/
  //-------------------------------------------------------------------
  getColorRent(vlrCusto, vlrVenda, tipoVen) {

    let cColor = { "color": "red" };
    let percRent: number = (parseFloat(vlrVenda) / parseFloat(vlrCusto) * 100) - 100;

    if (percRent <= 40) {
      cColor = { "color": "red" };
    } else if (percRent <= 50) {
      cColor = { "color": "orange" };
    } else if (percRent <= 56) {
      cColor = { "color": "green" };
    } else {
      cColor = { "color": "blue" };
    }

    if (tipoVen === "2" || parseFloat(vlrVenda) <= 0) {
      cColor = { "color": "white" };
    }

    return cColor;

  }

  getColorRentBack(vlrCusto, vlrVenda, tipoVen) {

    let cColor = { "background-color": "red" };
    let percRent: number = (parseFloat(vlrVenda) / parseFloat(vlrCusto) * 100) - 100;

    if (percRent <= 40) {
      cColor = { "background-color": "red" };
    } else if (percRent <= 50) {
      cColor = { "background-color": "orange" };
    } else if (percRent <= 56) {
      cColor = { "background-color": "green" };
    } else {
      cColor = { "background-color": "blue" };
    }

    if (tipoVen === "2" || parseFloat(vlrVenda) <= 0) {
      cColor = { "background-color": "white" };
    }

    return cColor;

  }

  getColorVencimento(dataVencimento) {

    let cColor = { "background-color": "green" };

    if (this.getVencimento(dataVencimento, 1)) {
      cColor = { "background-color": "red" };
    } else if (this.getVencimento(dataVencimento, 180)) {
      cColor = { "background-color": "orange" };
    }

    return cColor;

  }

  //-------------------------------------------------------------------
  /*/{WmsMais.doc} getColorRent
  Método utilizado para retornar cor da rentabilidade
  @author Kenny Roger Martins
  @since 30/01/2018
  /*/
  //-------------------------------------------------------------------
  getColorStar(vlrCusto, vlrVenda, color) {

    let cColor = { "color": color };
    let percRent: number = (parseFloat(vlrVenda) / parseFloat(vlrCusto) * 100) - 100;

    if (percRent >= 70) {
      cColor = { "color": "gold" };
    }

    return cColor;

  }

  //-------------------------------------------------------------------
  /*/{WmsMais.doc} getColorRent
  Método utilizado para retornar cor da rentabilidade
  @author Kenny Roger Martins
  @since 30/01/2018
  /*/
  //-------------------------------------------------------------------
  getRentStar(vlrCusto, vlrVenda) {

    let lRent70 = false;
    let percRent: number = (parseFloat(vlrVenda) / parseFloat(vlrCusto) * 100) - 100;

    if (percRent >= 70) {
      lRent70 = true;
    }

    return lRent70;

  }

  //-------------------------------------------------------------------
  /*/{WmsMais.doc} getFormatBRL
  Método utilizado para retornar número em moeda brasileira
  @author Kenny Roger Martins
  @since 30/01/2018
  /*/
  //-------------------------------------------------------------------
  getFormatBRL(n) {
    return "R$ " + Number(n).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
  }

  //-------------------------------------------------------------------
  /*/{WmsMais.doc} getFormatBRL
  Método utilizado para retornar número formatado
  @author Kenny Roger Martins
  @since 30/01/2018
  /*/
  //-------------------------------------------------------------------
  getFormatNumber(number, decimal) {
    return Number(number).toFixed(decimal).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
  }

  setAccessUrl(value: string) {
    this.accessUrl = value;
  }

  getAccessUrl() {
    return this.accessUrl;
  }

  setUserPass(value: string) {
    this.userpass = btoa(value);
  }

  getUserPass() {
    return this.userpass;
  }

  setEmpresa(value: string) {
    this.empresa = value;
  }

  getEmpresa() {
    return this.empresa;
  }

  getParamametro(nome: string) {

    let conteudo: any = false;

    this.parametros.forEach(element => {
      if (element.nome == nome) {
        conteudo = element.conteudo;
      }
    });

    return conteudo;

  }

}



// WEBPACK FOOTER //
// ./src/providers/global-service.ts